export async function saveTextFile(
  filename: string,
  contents: string
): Promise<'saved' | 'copied' | 'cancelled'> {
  // Mobile Safari + WKWebView-based in-app wallet browsers (Zerion, MetaMask,
  // Coinbase Wallet, etc.) lack showSaveFilePicker and don't reliably honor
  // <a download> on Blob URLs — the anchor click either no-ops or opens the
  // blob inline. Fall back to clipboard so the user actually gets the data.
  if (shouldUseClipboardFallback()) {
    await navigator.clipboard.writeText(contents);
    return 'copied';
  }

  const ext = filename.includes('.') ? filename.slice(filename.lastIndexOf('.')) : '';
  const picker = (window as unknown as { showSaveFilePicker?: (opts: unknown) => Promise<any> })
    .showSaveFilePicker;
  if (typeof picker === 'function') {
    try {
      const handle = await picker({
        suggestedName: filename,
        types: [{ description: 'Text file', accept: { 'text/plain': ext ? [ext] : [] } }],
      });
      const writable = await handle.createWritable();
      await writable.write(contents);
      await writable.close();
      return 'saved';
    } catch (e: unknown) {
      if ((e as { name?: string })?.name === 'AbortError') return 'cancelled';
      // Fall through to anchor download on any other failure.
    }
  }
  const blob = new Blob([contents], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return 'saved';
}

function shouldUseClipboardFallback(): boolean {
  if (typeof window === 'undefined') return false;
  const isTouch = window.matchMedia?.('(pointer: coarse)').matches ?? false;
  return isTouch && !('showSaveFilePicker' in window);
}
